

export class TrainerDto implements ITrainerDto {
    id!: number;
    empCode!: number;
    empName!: string | undefined;

    constructor(data?: ITrainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.empCode = _data["empCode"];
            this.empName = _data["empName"];
        }
    }

    static fromJS(data: any): TrainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["empCode"] = this.empCode;
        data["empName"] = this.empName;
        return data; 
    }
}

export interface ITrainerDto {
    id: number;
    empCode: number;
    empName: string | undefined;
}

